<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Conteúdos do Estágio</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="conteudo">Conteúdo</label>
                                    <input type="text" class="form-control" name="conteudo" placeholder="Conteúdo" v-model="filter.conteudo" />
                                </div>
                                <div class="form-group col-md-3">
                                    <label>Avaliação</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehAvaliacao" v-model="filter.ehAvaliacao" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehAvaliacao" v-model="filter.ehAvaliacao" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehAvaliacao" v-model="filter.ehAvaliacao" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group col-md-3">
                                    <label>Conteúdo Adicional</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="eAdicional" v-model="filter.eAdicional" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="eAdicional" v-model="filter.eAdicional" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="eAdicional" v-model="filter.eAdicional" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <section class="col-sm-12">
                                <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                                <button type="button" class="btn-large-40 btn-success uppercase pull-right" @click="openCreate()">
                                    Criar
                                </button>
                            </section>
                        </form>
                    </div>

                    <div class="alert col col-12 alert-block alert-info">
                        <p>
                            <i class="fa fa-info-circle"></i><b> CADASTRANDO CONTEÚDOS ADICIONAIS (AULA INAUGURAL, REUNIÃO DE PAIS, ETC.) *</b>
                        </p>
                        <p style="text-transform: none">
                            Se deseja cadastrar conteúdos adicionais para o estágio selecionado, por favor, siga as instruções definidas abaixo:<br />
                            <strong>Aula inaugural:</strong> cadastre aplicando o tempo de uma aula e a ordem 0 (zero). Isso garantirá que ela seja posicionada na primeira aula do plano de aulas.<br />
                            <strong>Demais conteúdos:</strong> é preciso saber em que momento do plano de aulas o conteúdo deverá ser inserido. Se, por exemplo, queremos cadastrar uma sessão de feedback duas aulas após as provas de meio de semestre,
                            é necessário contabilizarmos os tempos dos conteúdos após esse evento, de modo que a soma totalize a duração necessária para estas duas aulas. Logo após o último conteúdo necessário, adicionamos a sessão de feedback com mesma ordem.<br />
                            Exemplo: se o último conteúdo aplicado nas duas aulas após as provas de meio de semestre é o UNIT 5 - Act. 10 (do BASIC 1), com ordem 98, <strong>a sessão de feedback deverá ser cadastrada logo na sequência, utilizando a mesma ordem (98).</strong><br />
                            <br />
                            <strong>* Tais conteúdos serão aplicados somente em turmas CNA Conecta cadastradas na Digital School.</strong>
                        </p>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>Ordem <i @click="executeOrderBy('Ordem')" class="fa fa-sort"></i></th>
                                    <th>Conteúdo <i @click="executeOrderBy('Conteudo')" class="fa fa-sort"></i></th>
                                    <th>Tempo <i @click="executeOrderBy('Tempo')" class="fa fa-sort"></i></th>
                                    <th>Avaliação <i @click="executeOrderBy('EhAvaliacao')" class="fa fa-sort"></i></th>
                                    <th>Adicional <i @click="executeOrderBy('EAdicional')" class="fa fa-sort"></i></th>
                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{ item.ordem }}</td>
                                    <td>{{ item.conteudo }}</td>
                                    <td>{{ item.tempo }}</td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.ehAvaliacao, 'badge-danger': !item.ehAvaliacao }">{{item.ehAvaliacao ? 'Sim' : 'Não'}}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.eAdicional, 'badge-danger': !item.eAdicional }">{{item.eAdicional ? 'Sim' : 'Não'}}</span></td>

                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-primary" @click="openEdit({ estagioConteudoId: item.estagioConteudoId })">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-danger" @click="openRemove({ estagioConteudoId: item.estagioConteudoId })">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>

                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create v-if="dialogCreate" :estagio-id="estagioId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="estagioConteudoId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'

    export default {
        name: 'estagioconteudo',
        mixins: [base],
        props: { estagioId: Number },
        components: { formCreate, formEdit },
        data() {
            return {

                resources: {
                    filter: 'estagioconteudo',
                    remove: 'estagioconteudo'
                },

                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openEdit: function (model) {
                this.estagioConteudoId = model.estagioConteudoId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                this.filter.estagioId = this.estagioId;
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>